import React from 'react';
import PropTypes from 'prop-types';
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import SDKPayment from './SDKPayment';

class SDKPaymentModal extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      show: false,
    };

    this.handleShow = this.handleShow.bind(this);
    this.handleClose = this.handleClose.bind(this);
  }

  handleShow() {
    this.setState({ show: true, });
  }

  handleClose() {
    this.setState({ show: false, });
  }

  render() {
    const { show, } = this.state;
    const { payment, } = this.props;
    return (
      <>
        <Button variant="primary" onClick={this.handleShow}>
          Details
        </Button>

        <Modal show={show} onHide={this.handleClose} size="xl">
          <Modal.Header closeButton>
            <Modal.Title>
              SDK Payment:
              {` ${payment.id}`}
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            {(() => {
              if (show) {
                return <SDKPayment payment={payment} />;
              }
              return undefined;
            })()}
          </Modal.Body>
        </Modal>
      </>
    );
  }
}

SDKPaymentModal.propTypes = {
  payment: PropTypes.instanceOf(Object).isRequired,
};

export default SDKPaymentModal;
